import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ClockIcon(props) {
  return (
    <SvgIcon viewBox="0 0 21 21" title="Clock Icon" {...props}>
      <path d="M10.5262 0.08328C16.2781 0.0967129 20.9367 4.78307 20.9166 10.5358C20.8963 16.2728 16.2305 20.9199 10.4935 20.9167C4.74239 20.9134 0.0752587 16.2359 0.0833234 10.4833C0.0914091 4.73139 4.77195 0.0700648 10.5262 0.08328ZM10.5249 1.82458C5.73435 1.80672 1.85891 5.65422 1.82208 10.4643C1.78558 15.253 5.68671 19.1713 10.495 19.1753C15.2883 19.1794 19.1618 15.3154 19.177 10.5144C19.1923 5.7277 15.3241 1.84273 10.5249 1.82458ZM11.7024 4.05099V10.2198H15.9568V11.9878H10.0042V4.05099H11.7024Z" />
    </SvgIcon>
  );
}

export default ClockIcon;
